<template>
  <v-menu offset-y nudge-left="105" open-on-click>
    <template v-slot:activator="{on}">
      <v-btn v-on="on" icon>
        <v-icon class="primary--text">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list class="cursor-pointer">
      <v-list-item @click="$emit('onRename')">
        <v-list-item-title class="primary--text">{{ renameTitle }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$emit('onDelete')">
        <v-list-item-title class="red--text">{{ deleteTitle }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: {
    renameTitle: String,
    deleteTitle: String,
  },
}
</script>
